var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s_chat_middle_emoji_face"},[_c('span',{class:'__KEFU__emoji-'+ _vm.text,on:{"click":function($event){$event.stopPropagation();return _vm.emojiClick($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }